import { ApplyForm } from "../../components/Apply/ApplyForm";
import { AsssetDashLogo } from "../../components/AssetDashLogo";

export default function ApplyPage() {
  return (
    <div className="py-22p">
      <div className="mb-20 space-y-2">
        <AsssetDashLogo size="large" forceDark={true} />
        <p className="text-bold text-xl">Partner Portal</p>
      </div>
      <div className=" min-h-screen">
        <ApplyForm />
      </div>
    </div>
  );
}
